import style from "./BorderDashed.module.css";
import allContent from "../../../allContent";

function BorderDashed() {
  return (
    <div className={style.placeholder1}>
      <svg
        viewBox="0 0 151 151"
        preserveAspectRatio="none"
        fill="none"
        stroke="#fff"
        strokeWidth="1"
        strokeDasharray="9,8"
        style={{ width: "100%", height: "100%" }}
      >
        <rect x="2" y="2" width="146" height="146" rx="25" />
      </svg>
      <div className={style.imageWrapper}>
        <p
          style={{
            width: "80%",
            margin: "auto",
            textAlign: "center",
            fontSize: "2vh",
            color: "#fff",
          }}
        >
          {allContent.main.watch}
        </p>
      </div>
    </div>
  );
}

export default BorderDashed;
